<template>
   <div class="container-fluid">
      <div class="row">
         <div class="col-xl-3 col-lg-4">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">Edit Role</h4>
                  </div>
               </div>

               <div class="card-body">
                  <form>
                     <div class="form-group">
                        <label for="id">Role ID:</label>
                        <b-form-input type="text" id="id" min="1" step="1" placeholder="Role ID" :class="`form-control ${$v.form.id.$error ? 'is-invalid' : ''}`"
                           v-model="form.id" @input="$v.form.id.$touch()" @blur="$v.form.id.$touch()" readonly>
                        </b-form-input>
                        <div class="invalid-feedback"><small>Required field</small></div>
                     </div>
                           
                     <div class="form-group">
                        <label for="name">Role Name:</label>
                        <b-form-input type="text" id="name" placeholder="Role Name" :class="`form-control ${$v.form.name.$error ? 'is-invalid' : ''}`"
                           v-model="form.name" @input="$v.form.name.$touch()" @blur="$v.form.name.$touch()" required>
                        </b-form-input>
                        <div class="invalid-feedback"><small>Required field</small></div>
                     </div>

                     <div class="form-group">
                        <label for="description">Description:</label>
                        <b-form-input type="text" id="description" placeholder="Description" class="form-control" v-model="form.description">
                        </b-form-input>
                     </div>
                  </form>
               </div>
            </div>
         </div>

         <div class="col-xl-9 col-lg-8">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title"><h4 class="card-title">Role Information</h4></div>
               </div>

               <div class="card-body">
                  <div class="row">
                     <div class="form-group col-md-12">
                        <h5 class="mb-3 col-md-12">Pages:</h5>

                        <table id="menu-api-table" class="table table-striped table-bordered mt-4">
                           <thead>
                              <tr>
                                 <th class="">
                                    <label class="form-checkbox d-flex justify-content-center">
                                       <input class="align-bottom" type="checkbox" v-model="selectAll" @click="select()">
                                    </label>
                                 </th>
                                 <th>Menu Name</th>
                                 <th>API</th>
                              </tr>
                           </thead>

                           <tbody>
                              <tr v-for="menu in menus" v-bind:key="menu.id">
                                 <td>
                                    <label class="form-checkbox d-flex justify-content-center mb-0">
                                       <input class="align-bottom" type="checkbox" :value="menu.id" v-model="selected">
                                    </label>
                                 </td>
                                 <td>{{menu.name}}</td>
                                 <td>
                                    <div v-for="api in menu.cp_menu_apis" v-bind:key="api.id">
                                       <input type="checkbox" :value="api.api_id" v-model="selectedAPI" class="mr-2 align-middle">{{api.cp_sys_api.name}}
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>

                  <div class="col-md-12 form-group">
                     <button type="button" class="btn btn-primary float-right" v-on:click="update">Save</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'

const config = require("../../../../../config");
Vue.use(VueAxios, axios)

export default {
   name: "RoleEdit",
   data() {
      return {
         form: {
            id: '',
            name: '',
            description: ''
         },
         menus: [],
         selected: [],
         selectedAPI: [],
         selectAll: false
      }
   },
   mixins: [validationMixin],
   validations: {
      form: {
         id: { required, minValue: minValue(1) },
         name: { required }
      }
   },
   mounted: async function() {
      try {
         const roleDataRes = await axios.get(config.api.URL + '/api/roles/get', { params: { id: this.$route.params.id, m: this.$route.meta.uid } });
         this.form = roleDataRes.data;

         const res = await axios.get(config.api.URL + '/api/menuapi/get', { params: { m: this.$route.meta.uid } });
         this.menus = res.data;

         const menures = await axios.get(config.api.URL + '/api/menu/get', { params: { m: this.$route.meta.uid, id: this.$route.params.id } });
         menures.data.forEach(element => {
            this.selected.push(element.menu_id.toString());
            this.selec
            if(element.api_id_list != null) {
               var array = JSON.parse("[" + element.api_id_list + "]");
               array.forEach(ele => {
                  this.selectedAPI.push(ele.toString())
               });
            }
         });
      } catch(error) {
         alert("Error!")
         console.log("error", error)
      }
   },
   methods: {
      update: async function() {
         try {
            this.$v.$touch();
            if(!this.$v.$invalid && confirm("Are you sure you want to save this record?")) {
               await axios.post(config.api.URL + '/api/roles/update', this.form, { params: { m: this.$route.meta.uid } });
              
               var dataToSave = [];
               await this.menus.forEach(menu => {
                  if(this.selected.includes(menu.id)) {
                     let apiList = [];
                     if(menu.cp_menu_apis.length != 0) {
                        menu.cp_menu_apis.forEach(api => {
                           if(this.selectedAPI.includes(api.api_id)) { apiList.push(api.api_id) }
                        });
                     }
                     var m = {
                        role_id: this.form.id,
                        menu_id: menu.id,
                        api_id_list: apiList
                     };

                     dataToSave.push(m);
                  }
               });
               
               await axios.post(config.api.URL + '/api/role-setting/update', dataToSave, { params: { m: this.$route.meta.uid } });
               await this.$router.push({path: '/role/list'});
               alert("Role is updated successfully.");
            }
         } catch(error) {
            alert("Error!")
            console.log("error", error)
         }
      },
      select: async function() {
			this.selected = [];
         this.selectedAPI = [];
			if(!this.selectAll) {
				for(let i in this.menus) {
               let menu = this.menus[i];
               this.selected.push(menu.id);

               for(let j in menu.cp_menu_apis) {
                  let api = menu.cp_menu_apis[j];
                  this.selectedAPI.push(api.api_id);
               }
				}
			}
		}
   }
}
</script>